import { render } from "./ReminderMessageListItem.vue?vue&type=template&id=52a8735b&scoped=true"
import script from "./ReminderMessageListItem.vue?vue&type=script&lang=js"
export * from "./ReminderMessageListItem.vue?vue&type=script&lang=js"

import "./ReminderMessageListItem.vue?vue&type=style&index=0&id=52a8735b&scoped=true&lang=css"
import "./ReminderMessageListItem.vue?vue&type=style&index=1&id=52a8735b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a8735b"]])

export default __exports__